import About from './components/About';
import Banner from './components/Banner';
import Contact from './components/Contact';
import Details from './components/Details';
import Footer from './components/Footer';
import Header from './components/Header';
import React, { useState } from 'react';

function App() {
  const [scrollPosition, updateScrollPosition] = useState();

  const scroll = () => {
    const position = window.pageYOffset;
    updateScrollPosition(position);
  };

  React.useEffect(() => {
    window.addEventListener("scroll", scroll, {
      passive: true
    });

    return () => {
      window.removeEventListener("scroll", scroll);
    };
  }, []);

  return (
    <div class="h-100 position-absolute w-100">
      <Banner />
      <Header scrollPosition={scrollPosition} />
      <Details />
      <About />
      <Contact />
      <Footer />

      <a href="#">
        <button class="back border-0 btn btn-primary fixed-bottom mb-3 me-3 ms-auto rounded-pill" type="button">
          <i class="bi bi-arrow-up" />
        </button>
      </a>
    </div>
  );
}

export default App;